export default {
    methods: {
        phoneFormat(phone) {
            if (phone) {
                let aux = typeof phone === 'string' ? phone.trim() : `${phone}`;
                if (aux.length > 10) {
                    return aux.substring(aux.length - 10);
                }
            }
            return `${phone}`;
        }
    }
};
